import { createStyles } from '@mantine/core';

export const useEditorStyles = createStyles((theme) => ({
  content: {
    padding: '0.5rem 0 2rem 0', // Reduced top padding to 0.5rem
    backgroundColor: theme.white,
    color: theme.white,
    '*:focus': {
      outline: 'none'
    },
    '& .ProseMirror': {
      maxWidth: '850px',
      margin: '0 auto',
      // Best native fonts in order
      fontFamily:
        '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
      '& p': {
        margin: '0.5rem 0',
        padding: 0,
        lineHeight: 1.5,
        fontSize: '1rem',
        color: '#37352f'
      },
      '& h1': {
        fontSize: '2.125rem',
        fontWeight: 700,
        marginTop: '2rem',
        marginBottom: '0.5rem',
        color: '#37352f'
      },
      '& h2': {
        fontSize: '1.5rem',
        fontWeight: 600,
        marginTop: '1.5rem',
        marginBottom: '0.5rem',
        color: '#37352f'
      },
      '& h3': {
        fontSize: '1.25rem',
        fontWeight: 600,
        marginTop: '1rem',
        marginBottom: '0.5rem',
        color: '#37352f'
      },
      '& ul, & ol': {
        margin: '0.5rem 0',
        padding: '0 0 0 1.5rem',
        color: '#37352f',
        listStylePosition: 'outside'
      },
      '& li': {
        margin: '0.25rem 0',
        padding: '0 0 0 0.5rem',
        '& p': {
          margin: 0
        }
      },
      '& ul': {
        listStyleType: 'disc'
      },
      '& ol': {
        listStyleType: 'decimal'
      },
      a: {
        color: 'rgba(55, 53, 47, 0.7)',
        textDecoration: 'underline',
        textDecorationColor: 'rgba(55, 53, 47, 0.3)',
        cursor: 'pointer',
        '&:hover': {
          textDecorationColor: 'rgba(55, 53, 47, 0.6)'
        }
      },
      code: {
        backgroundColor: 'rgba(135, 131, 120, 0.15)',
        borderRadius: '0.25em',
        boxDecorationBreak: 'clone',
        fontSize: '0.875rem',
        padding: '0.20em',
        color: '#37352f'
      },
      '& p.is-editor-empty:first-of-type::before': {
        color: 'rgba(55, 53, 47, 0.4)',
        content: 'attr(data-placeholder)',
        float: 'left',
        height: 0,
        pointerEvents: 'none'
      },
      '& p.is-empty::before': {
        color: 'rgba(55, 53, 47, 0.4)',
        content: 'attr(data-placeholder)',
        float: 'left',
        height: 0,
        pointerEvents: 'none'
      },
      '& img': {
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        '&:hover': {
          boxShadow: '0 0 0 2px rgba(55, 53, 47, 0.2)'
        },
        '&.ProseMirror-selectednode': {
          boxShadow: '0 0 0 2px rgba(99, 102, 241, 0.6)',
          background: 'rgba(99, 102, 241, 0.05)'
        }
      }
    }
  }
}));
